import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const adminInfo = JSON.parse(localStorage.getItem('adminInfo') || '{}');
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const resolvedToken =
    userInfo?.token ||
    localStorage.getItem('token') ||
    localStorage.getItem('userToken');
  const hasUserId = Boolean(userInfo?.id || userInfo?._id);

  // If admin is logged in, allow access.
  if (adminInfo && adminInfo.token) {
    return children;
  }

  // If regular user is logged in with any accepted token, allow access.
  if (hasUserId && resolvedToken) {
    return children;
  }

  // If no authentication found, redirect to login.
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
